import { GridApi } from '@ag-grid-community/core';

/**
 * Update AG Grid rows using the transaction API.
 * @remarks Use this if you want the update to trigger an event.
 * @param api The API instance for the grid you wish to update
 * @param updates An array of updated data rows (full row objects).
 */
export function updateGridData<TData>(
    api: GridApi<TData> | undefined
    , updates: TData[] | undefined
) {
    if (api && updates?.length) {
        api.applyTransaction({ update: updates });
    }
}
